import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function segments(pathname: string): string[] {
    return pathname.split('/').filter(Boolean);
}
function isSameScreen(prevPathname: string, nextPathname: string): boolean {
    const prev = segments(prevPathname);
    const next = segments(nextPathname);
    if (prev.length === 0 || next.length === 0) return false;
    const [shorter, longer] =
        prev.length <= next.length ? [prev, next] : [next, prev];
    return shorter.every((segment, i) => segment === longer[i]);
}
function ScrollToTop(): null {
    const { pathname } = useLocation();
    const prevPathname = useRef<string | undefined>(undefined);

    useEffect(() => {
        const prev = prevPathname.current;
        prevPathname.current = pathname;
        if (prev !== undefined && isSameScreen(prev, pathname)) return;
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export default ScrollToTop;
